module.exports = __webpack_public_path__ + "static/media/peacock-logo-white.ea21a21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/peacock-logo-white.png
// module id = 616
// module chunks = 0